/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * OddEvenPad.tsx - Odd/Even input
 */

import {
  TouchableOpacity, View, Text, StyleSheet
} from 'react-native';
import { RFPercentage } from 'react-native-responsive-fontsize';
import * as colours from '../../../colours';


interface OddEvenPadProps {
  handleInputEvent(input: 'Odd' | 'Even'): void;
  disabled: boolean;
}

const OddEvenPad = ({ handleInputEvent, disabled }: OddEvenPadProps) => {
  return (
    <View style={styles.pad}>
      <TouchableOpacity
        key="Odd"
        style={styles.button}
        onPress={() => handleInputEvent('Odd')}
        disabled={disabled}>
        <Text style={styles.buttonText} allowFontScaling={false}>Odd</Text>
      </TouchableOpacity>
      
      <TouchableOpacity
        key="Even"
        style={styles.button}
        onPress={() => handleInputEvent('Even')}
        disabled={disabled}>
        <Text style={styles.buttonText} allowFontScaling={false}>Even</Text>
      </TouchableOpacity>
    </View>
  );
};

export default OddEvenPad;

const styles = StyleSheet.create({
  pad: {
    flexWrap: 'wrap',
    flexDirection: 'row',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },

  button: {
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    width: '33%',
    height:'100%',
  },

  buttonText: {
    color: '#575756',
    fontSize: RFPercentage(5),
    textAlign: 'center',
    fontFamily: 'WhiteRoseMathsFont',
  },

  confirmText: {
    color: colours.confirm
  },

  deleteText: {
    color: colours.backspace
  }

});
